<template>
  <div class="flex-row box" @click="$emit('notification:read', notification)">
    <div class="noti_img">
      <base-image
        :src="notificationIcon.iconSrc"
        :alt="notificationIcon.iconAlt"
        :type-for-skin="notificationIcon.typeForSkin"
      ></base-image>
    </div>
    <div class="flex-column">
      <div class="flex-row top_row">
        <p class="date_time">{{ notificationDate }}</p>

        <p v-if="isNotificationUnread" class="new">{{ getTranslations.notification_page_unread_notification_flag }}</p>
      </div>

      <div class="flex-column noti_content">
        <h3>{{ getTranslations[notificationTitle] }}</h3>

        <p>
          <template v-for="descriptionInfo in notificationDescription">
            <template v-if="descriptionInfo.type === descriptionTextTypeEnum.TRANSLATION_KEY">
              {{ getTranslations[descriptionInfo.value] }}
            </template>

            <template v-else-if="descriptionInfo.type === descriptionTextTypeEnum.DYNAMIC_VALUE">
              <span>{{ descriptionInfo.value }}</span>
            </template>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseImage from '../common/image/BaseImage'
import { notificationDescriptionTextTypeEnum, notificationTypeEnum } from '../../constants/notification';

const moment = require('moment')

export default {
  name: 'NotificationListItem',
  components: {BaseImage},
  emits: ['notification:read'],
  props: {
    notification: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      descriptionTextTypeEnum: notificationDescriptionTextTypeEnum
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    notificationIcon () {
      return this.notification
        ? {
          iconSrc: this.notification.iconSrc,
          iconAlt: this.notification.iconAlt,
          typeForSkin: (this.notification.type === notificationTypeEnum.ACHIEVEMENT) ? 'achievement' : '',
        }
        : {iconSrc: '', iconAlt: '', typeForSkin: ''}
    },
    notificationDate () {
      return (this.notification && this.notification.date && moment(this.notification.date).format('DD/MM/YYYY, HH:mm:ss')) || '-'
    },
    isNotificationUnread () {
      return !!this.notification && this.notification.isUnread
    },
    notificationTitle () {
      return (this.notification && this.notification.title) || ''
    },
    notificationDescription () {
      return (this.notification && Array.isArray(this.notification.description))
        ? this.notification.description
        : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/NotificationListItem.vue